import * as React from 'react';
import { BaseRouteProps } from '../../interfaces';
import { } from '../../interfaces';
import { SurveyVersion, ScoreType, CharacteristicScore, Characteristic } from '../../models';
import { ScoreTypeDataService, SurveyVersionDataService, CharacteristicDataService } from '../../services';
import { NavLink } from 'react-router-dom';
import { } from 'react-form';
import { ScoreTypeForm } from './ScoreTypeForm';

interface ScoreTypeCreateState {
    scoreType: ScoreType;
    surveyVersion: SurveyVersion | undefined;
    characteristicScores: CharacteristicScore[];
    characteristics: Characteristic[];
    defaultValues: any;
}

export class ScoreTypeCreate extends React.Component<BaseRouteProps<{ id: number }>, ScoreTypeCreateState> {
    private surveyVersionDataService = new SurveyVersionDataService(this.props.notificationService);
    private scoreTypeDataService = new ScoreTypeDataService(this.props.notificationService);
    private characteristicDataService = new CharacteristicDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{ id: number }>) {
        super(props);

        this.state = {
            scoreType: new ScoreType(),
            surveyVersion: undefined,
            characteristicScores: [],
            characteristics: [],
            defaultValues: {}
        };

        this.save = this.save.bind(this);
    }

    public componentDidMount() {

        this.surveyVersionDataService.get(this.props.match.params.id).then((surveyVersion: SurveyVersion) => {
            this.setState({
                surveyVersion: surveyVersion
            });

            this.characteristicDataService.getAll().then((characteristics: Characteristic[]) => {
                this.setState({
                    characteristics: characteristics
                });
            });
        });

    }

    public render() {

        return (
            <div>
                <div className="content-header">
                    <div className="content-container">
                        <div className="title">
                            <NavLink to={'/surveyversion/' + this.props.match.params.id + '/scoretypes'}>
                                <span className="glyphicon glyphicon-triangle-left" />
                            </NavLink>
                            &nbsp; 
                            Create Raw Score
                        </div>
                    </div>
                </div>

                <div className="content-body">
                    <div className="content-container">
                        <ScoreTypeForm defaultValues={this.state.scoreType} surveyVersionId={this.props.match.params.id} submit={this.save} notificationService={this.props.notificationService} />
                    </div>
                </div>
            </div>);
    }

    private save(values: any) {
        if (this.state.surveyVersion === undefined) {
            return;
        }

        values.surveyVersionId = this.state.surveyVersion.id;
        this.scoreTypeDataService.create(values).then((success) => {
            if (this.state.surveyVersion === undefined) {
                return;
            }
            this.props.history.push('/surveyversion/' + this.state.surveyVersion.id + '/scoretypes');
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/scoreType/ScoreTypeCreate.tsx